import { apiClient } from "../apiClient";

const THAM_SO_HE_THONG_ENDPOINT = 'tham-so-he-thong';
export const thamSoHeThongChucNangApi = {
    SelectByChucNang: (ma_chuc_nang: string) => apiClient.get(`${THAM_SO_HE_THONG_ENDPOINT}/chuc-nang/${ma_chuc_nang}`)
}